import React from 'react';

const PrivacyPolicyPage = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <h1 className="text-3xl font-bold text-gray-900 mb-8">Privacy Policy & Cookies</h1>
      
      <div className="prose max-w-none">
        <h2>Cookies We Use</h2>
        <p>This website uses the following cookies:</p>
        
        <h3>Essential Cookies</h3>
        <ul>
          <li><strong>Authentication:</strong> To keep you logged in</li>
          <li><strong>Preferences:</strong> To remember your settings</li>
        </ul>
        
        <h3>Analytics Cookies</h3>
        <ul>
          <li><strong>Google Analytics:</strong> To understand how visitors use our site and improve user experience</li>
        </ul>
        
        <h2>Your Choices</h2>
        <p>You can control cookies through your browser settings or by using our cookie banner when you first visit.</p>
        
        <p>Last updated: {new Date().toLocaleDateString()}</p>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;